import { useRecoilValue } from "recoil";
import { authState } from "@/comn/features/recoil";
import { Icon } from "@/comn/components";
import { useLogin } from "@/comn/features/authentication/useLogin";

export const NavigationInfoClosed = () => {
    const auth = useRecoilValue(authState);
    const { handleLogin, handleCompany, logout } = useLogin();

    return (
        <div className="bg-primary h-[120px] p-4 relative rounded-t-[20px] rounded-br-[50px] flex flex-col justify-around items-center">
            {auth.isSignedIn && (
                <>
                    <button type="button" className="bg-black/10 p-2 rounded-full transition hover:bg-white/30">
                        <Icon className="rotate-90 text-primary-contrast" size="sm" icon="out" onClick={logout} />
                    </button>
                    {auth?.coUsrYn === "Y" && (
                        <button type="button" className="bg-black/10 p-2 rounded-full transition hover:bg-white/30">
                            <Icon className="text-primary-contrast" size="sm" icon="setting" onClick={handleCompany} />
                        </button>
                    )}
                </>
            )}
            {!auth.isSignedIn && (
                <button type="button" className="bg-black/10 p-2 rounded-full transition hover:bg-white/30">
                    <Icon className="rotate-90 text-primary-contrast" size="sm" icon="in" onClick={handleLogin} />
                </button>
            )}
        </div>
    );
};
